export function getCurrentUser() {
	return localStorage.getItem("rankerx-user");
}

export function setCurrentUser(user) {
	return localStorage.setItem("rankerx-user", user);
}

export function removeCurrentUser() {
	return localStorage.removeItem("rankerx-user");
}